import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '@orobix/orobix-fe-components'
import { useQuery } from '@tanstack/react-query'
import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'

import { useStore } from '../../store/store'
import { get } from '../../utils/api'
import { handleApiErrors } from '../../utils/apiErrors'

const useDownloadOutcomes = (
  trainingTestId: number,
  trainingId: number | undefined,
  trainingTestName?: string
) =>
  useQuery<void>(
    ['tasks', 'download', trainingTestId],
    () =>
      get<BlobPart>(
        `/training_test_outcomes/export-csv?training_test=${trainingTestId}`
      )
        .then((result) => {
          const link = document.createElement('a')
          const now = format(new Date(), 'yyyyMMdd-HHmmss')

          link.target = '_blank'
          link.download = `Export_Test_${trainingTestName}_(${trainingTestId})_Training_${trainingId}_${now}.csv`
          link.href = URL.createObjectURL(
            new Blob([result], { type: 'application/csv' })
          )
          link.click()
        })
        .catch(handleApiErrors),
    {
      enabled: false,
    }
  )

export const DownloadOutcomesButton = ({
  trainingTestId,
}: {
  trainingTestId: number
}) => {
  const { t } = useTranslation()
  const { training, trainingTest } = useStore()
  const { isFetching, refetch } = useDownloadOutcomes(
    trainingTestId,
    training?.id,
    trainingTest?.name
  )

  return (
    <Button
      label={t('Export CSV')}
      onClick={() => refetch()}
      loading={isFetching}
      icon={<FontAwesomeIcon icon={faDownload} />}
      buttonType="button"
      type="blank-default"
    />
  )
}
